import React from "react";
import { Card, CardContent, Avatar } from "@material-ui/core";
function TestimonialCard({ name, desc, image, position }) {
  return (
    <Card className={"testimonialCard"}>
      <CardContent className={"testimonialcardContent"}>{desc}</CardContent>
      <div className={"testimonialCardOwner"}>
        <Avatar
          style={{
            width: 100,
            height: 100,
            border: "5px solid #7070704D"
          }}
          alt={name}
          src={image}
        />
        <aside>
          <h4>{name}</h4>
          <h6>{position}</h6>
        </aside>
      </div>
    </Card>
  );
}

export default TestimonialCard;
